import { classNames, twMerge } from '@panwds/tailwindcss';
import React from 'react';
import { testIdGen, useTitle } from '../../utils/index.js';
import { LoadingPage } from './LoadingPage.js';
/**
 * Helps layout controls of a page.
 * Will handle spacing of common page elements.
 */
export function PageLayout({ children, documentTitle, header, isLoading = false, tabList, filterBar, noPadding = false, noMargin = false, overflow = false, addClassName = '', dataTestId }) {
    useTitle(documentTitle);
    if (noPadding || overflow) {
        console.warn('noPadding and overflow props has been deprecated and will be ignored!');
    }
    return (React.createElement("div", { "data-testid": dataTestId || `header-${typeof documentTitle === 'string' && testIdGen(documentTitle)}`, className: twMerge('twds-flex twds-flex-col twds-w-full twds-bg-gray-50 dark:twds-bg-gray-1050', addClassName) },
        React.createElement("div", null, header),
        tabList && React.createElement("div", null, tabList),
        filterBar && (React.createElement("div", null, React.isValidElement(filterBar) &&
            React.cloneElement(filterBar, {
                ...filterBar.props,
                className: classNames('twds-pb-0 twds-pt-4', filterBar.props?.className)
            }))),
        React.createElement("div", { className: noMargin || tabList ? '' : 'twds-m-4' }, isLoading ? React.createElement(LoadingPage, null) : children)));
}
//# sourceMappingURL=PageLayout.js.map